import type { Polygon } from 'geojson';

import type { PointArray } from '../types/contour-definition-array-type';

import { area, lineString, polygon } from '@turf/turf';

export function pointArrayToPolygon(pointArray: PointArray) {
  if (pointArray.length < 4) {
    throw new Error('A polygon must have at least 4 points');
  }
  const rawValuesArray = pointArray.map(point => [point.x, point.y]);

  return polygon([rawValuesArray]);
}

export function pointArrayToLineString(pointArray: PointArray) {
  const rawValuesArray = pointArray.map(point => [point.x, point.y]);
  return lineString(rawValuesArray);
}

export function pointArrayToTurfFeature(pointArray: PointArray) {
  if (pointArray.length < 2) {
    throw new Error('Array is empty.');
  }
  // Check if it is a closed loop:
  if (
    pointArray[0].x === pointArray[pointArray.length - 1].x
    && pointArray[0].y === pointArray[pointArray.length - 1].y
  ) {
    return pointArrayToPolygon(pointArray); // if closed loop return polygon
  }
  // If not closed loop return linestring
  return pointArrayToLineString(pointArray);
}

export function getPolygonArea(inputPoly: Polygon): number {
  return area(inputPoly);
}

export function orderPolygonsByArea(inputPolyArr: Polygon[]) {
  return inputPolyArr.sort((a, b) => getPolygonArea(b) - getPolygonArea(a));
}

export function getBiggestPolygon(inputPolyArr: Polygon[]) {
  return orderPolygonsByArea(inputPolyArr)[0];
}
